import { Hidden } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import { harvestYearDetail } from "../../../config/harvestYearDetail";
import DropdownOptions from "../../../constants/DropdownOptions";
import {
  commodityList,
  getAllContractList,
  getCommodityVariertyList,
  getContractStage,
  getContractType,
  getDestinationByType,
  getSelectedContractDetail,
  InternalDestinationList,
} from "../../../modules/contract/action";
import {
  getAllTicketList,
  getCounterpartList,
  getLoadNumberIndicatorList,
  getOriginType,
  getCounterPartyDashboard,
  getDataFromHarvestYear,
  getCounterPartyTicketList
} from "../../../modules/ticket/action";
import { trucklineListAction } from "../../../modules/truckline/action";
import "../../../style";
import Button from "../../FormElement/Button";
import DataRangePicker from "../../FormElement/DatePickerRange";
import Dropdown from "../../FormElement/Dropdown";
import { validForm } from "../../FormElement/FormValidator";
import MultipleSelect from "../../FormElement/MultipleSelect";
import { isCounterParty } from "../../Common/CheckAuthorization";
import axios from "axios";
import { config } from "../../../config/appConfig";

const defaultDestinationTypeId = "2";

class ReportsFormList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reportsFilter: {
        startdate: "",
        enddate: "",
        contract: "",
        origin: "",
        loadnumberindicator: "",
        commodity: "",
        commodityVariety: [],
        commodityVarietyListOption: [],
        counterpart: "",
        destination: "",
        truckline: "",
        // subFarms:"",
        farm:'',
        farmId: this.props.SubFarmId
          ? this.props.SubFarmId
          : userFarmDetail().id || this.props.MainFarmId,
        harvestYear: isCounterParty()?'':harvestYearDetail().name,
        counterPartyEnum:'ONBOARDED',
        status:'',
      },
      ONBOARDED:'ONBOARDED',
      commodityVarietyListOption: [],
      formErrors: {},
      isValid: true,
      successMessage: "",
      errorMessage: {},
      getOriginListOptions: [],
      showDateRange: false,
      dateRangeValue: "",
      comodityVariety: {
        selectedOptions: []
      },
      counterPartData:[]
    };
  }

  componentDidMount() {
    const { selectedYear } = this.props;
  }

  componentWillMount() {
    const destinationType = "External";

    let id = this.props.SubFarmId
      ? this.props.SubFarmId
      : userFarmDetail().id
      ? userFarmDetail().id
      : this.props.MainFarmId;
    const harvestYearId = harvestYearDetail().name;
    if(isCounterParty()){
      this.props.actions.getCounterPartyDashboard(100000)
    this.props.actions.getCounterPartyTicketList()
    }
    else{
    this.props.actions.getCommodityVariertyList(harvestYearId);
    this.props.actions.getAllContractList(id, harvestYearId);
    this.props.actions.getCounterpartList(id, harvestYearId);
    this.props.actions.getContractStage();
    this.props.actions.getContractType();
    
    this.props.actions.getLoadNumberIndicatorList(harvestYearId);
    this.props.actions.getDestinationByType(destinationType, harvestYearId);
    this.props.actions.InternalDestinationList("Internal").then(() => {
      this.props.actions.getOriginType().then(() => {
        this.getOriginList();
      });
    });
    this.props.actions.trucklineListAction();
  }
    
  }
  multiSelectHandleChange = selectedVarietyArr => {
    const selectedOptionIds = selectedVarietyArr
      ? selectedVarietyArr.map(selectedVariety => selectedVariety.value)
      : [];
    this.setState(prevState => {
      return {
        reportsFilter: {
          ...prevState.reportsFilter,
          commodityVariety: selectedOptionIds
        }
      };
    });
  };
  handleChange = event => {
    const { name, value, label } = event.target;
    if (name === "commodity") {
      if(!isCounterParty()){
      this.getVariertyList(value);
      }
      else{
        this.getVariertyListforCounterparty()
      }
      if (value === "") {
        this.setState(
          prevState => {
            return {
              reportsFilter: {
                ...prevState.reportsFilter,
                commodityVariety: ""
              }
            };
          },
          () => {
            this.setState({
              comodityVariety: { selectedOptions: [] }
            });
          }
        );
      }
    }
    if (name === "originId") {
      this.setState(prevState => {
        return {
          reportsFilter: {
            ...prevState.reportsFilter,
            [name]: value,
            origin: value ? value.toString().split("_")[0] : "",
            originTypeId: value ? value.toString().split("_")[1]||"2" : "2"
          }
        };
      });
    } else {
       console.log(name)
       if(name==="counterpart"&& label){
        this.setState({ONBOARDED:label.includes('✅')?'ONBOARDED':'VIRTUAL'
      })
}

      this.setState(
        prevState => {
          return {
            reportsFilter: {
              ...prevState.reportsFilter,
              [name]: value
            }
          };
        },
        () => {
          const { reportsFilter, formErrors } = this.state;
          this.setState({
            isValid: validForm(formErrors, reportsFilter)
          });
        }
      );
    }

    if(name==='harvestYear'){
      this.props.actions.getDataFromHarvestYear(value)
    }
  };
  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        this.setState({
          isValid: validForm(this.state.formErrors)
        });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
  
    if (
      nextProps.selectedYear &&
      nextProps.selectedYear !== this.props.selectedYear
    ) {
      const destinationType = "External";

      let id = this.props.SubFarmId
        ? this.props.SubFarmId
        : userFarmDetail().id;
      const harvestYearId = harvestYearDetail().name;
      this.props.actions.getCommodityVariertyList(harvestYearId);
      this.props.actions.getAllContractList(id, harvestYearId);
      this.props.actions.getCounterpartList(id, harvestYearId);
      this.props.actions.getContractStage();
      this.props.actions.getContractType();
      this.props.actions.getLoadNumberIndicatorList(harvestYearId);
      this.props.actions.getDestinationByType(destinationType, harvestYearId);
      this.props.actions.InternalDestinationList("Internal").then(() => {
        this.props.actions.getOriginType().then(() => {
          this.getOriginList();
        });
      });
      this.props.actions.trucklineListAction();
    }

if(nextProps.counterPartyDashboard != this.props.counterPartyDashboard){
  if( isCounterParty()){
    setTimeout(()=>{
      if(this.getHarvestYearOptionsList() && this.getHarvestYearOptionsList()[0]){
      this.props.actions.getDataFromHarvestYear(this.getHarvestYearOptionsList()? this.getHarvestYearOptionsList()[0] ? this.getHarvestYearOptionsList()[0].id:'':'') 
    }
    },500)
    if(isCounterParty() && !this.state.reportsFilter.harvestYear){
  this.setState({
    reportsFilter: {
      startdate: "",
      enddate: "",
      contract: "",
      origin: "",
      loadnumberindicator: "",
      commodity: "",
      commodityVarietyListOption: [],
      counterpart: "",
      destination: "",
      truckline: "",
      farm:"",
      subFarm:'',
      farmId: this.props.SubFarmId
        ? this.props.SubFarmId
        : userFarmDetail().id || this.props.MainFarmId,
      harvestYear:  this.getHarvestYearOptionsList()? this.getHarvestYearOptionsList()[0] ? this.getHarvestYearOptionsList()[0].id:'':'',
      status:''
    },
    formErrors: {}
  });
}
}
}


    if (
      nextProps.MainFarmId !== this.props.MainFarmId &&
      nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id
    ) {
      this.setState({
        reportsFilter: {
          startdate: "",
          enddate: "",
          contract: "",
          origin: "",
          loadnumberindicator: "",
          commodity: "",
          commodityVarietyListOption: [],
          counterpart: "",
          destination: "",
          truckline: "",
          farm:"",
          subFarm:'',
          farmId: this.props.SubFarmId
            ? this.props.SubFarmId
            : userFarmDetail().id || this.props.MainFarmId,
          harvestYear: isCounterParty() ? 2023: harvestYearDetail().name,
          status:''
        },
        formErrors: {}
      });
      const destinationType = "External";

      let id = this.props.SubFarmId
        ? this.props.SubFarmId
        : userFarmDetail().id
        ? userFarmDetail().id
        : this.props.MainFarmId;
      const harvestYearId = harvestYearDetail().name;
      this.props.actions.getCommodityVariertyList(harvestYearId);
      this.props.actions.getAllContractList(id, harvestYearId);
      this.props.actions.getCounterpartList(id, harvestYearId);
      this.props.actions.getContractStage();
      this.props.actions.getContractType();
      this.props.actions.getLoadNumberIndicatorList(harvestYearId);
      this.props.actions.getDestinationByType(destinationType, harvestYearId);
      this.props.actions.InternalDestinationList("Internal").then(() => {
        this.props.actions.getOriginType().then(() => {
          this.getOriginList();
        });
      });
      this.props.actions.trucklineListAction();
    }
  }

  generateReport = e => {
    e.preventDefault();
    const { reportsFilter } = this.state;
    console.log(reportsFilter);
    if(!isCounterParty()){
    reportsFilter.farmId = this.props.SubFarmId
      ? this.props.SubFarmId
      : userFarmDetail().id || this.props.MainFarmId;
      delete reportsFilter.farm
      delete reportsFilter.status
      reportsFilter.harvestYear = harvestYearDetail().name;
      reportsFilter['counterPartyEnum'] = this.state.ONBOARDED
    }
  
    // reportsFilter.commodityVariety = [
    //   reportsFilter.commodityVarietyListOption
    // ];
    if(isCounterParty()){
      delete reportsFilter.counterPartyEnum;
      reportsFilter.farmId = reportsFilter.farm
      delete reportsFilter.contract
      delete reportsFilter.origin
      delete reportsFilter.loadnumberindicator
      delete reportsFilter.commodityVariety
      delete reportsFilter.commodityVarietyListOption
      delete reportsFilter.counterpart
      if(reportsFilter['harvestYear']===''){
        reportsFilter['harvestYear'] = this.getHarvestYearOptionsList()? this.getHarvestYearOptionsList()[0] ? this.getHarvestYearOptionsList()[0].id:'':''
      }
    }
    var finalFilter = JSON.parse(JSON.stringify(reportsFilter));
    var queryString = Object.keys(finalFilter)
      .map(key => {if(key=='farm'){
        return null
      }
        return key + "=" + reportsFilter[key] || "";
      })
      .join("&");
    this.props.reportGenerated(queryString);
  };

  getfilterCommodityList = () => {
    const { commodityVarietyList, counterPartyDashboard, harvestData } = this.props;
    let comm = commodityVarietyList !== undefined ? commodityVarietyList : {};

    let commarray = [];
    if(isCounterParty() && harvestData && harvestData.COMMODITY){
     
      return harvestData.COMMODITY


    }
    else{
    commarray = Object.keys(comm).map(value => {
      return {
        id: comm[value].commodityResponseDTO.id,
        name: comm[value].commodityResponseDTO.name
      };
    });
  }
    const filteredArr = commarray.reduce((acc, current) => {
      const x = acc.find(item => item.id === current.id);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return filteredArr;
  };
  getStatusOptionsList = () =>{
    const { counterPartyDashboardm, harvestData } = this.props;
    if(isCounterParty()){
      if(harvestData && harvestData.STATUS)
     return harvestData.STATUS
    }
  }

  getHarvestYearOptionsList = () =>{
    const { counterPartyDashboard, CounterPartyTicketList } = this.props;
    if(isCounterParty()){
      let commarray = [];
      if (isCounterParty() && CounterPartyTicketList &&  CounterPartyTicketList.length > 0) {
        // Create an array of objects with id and name
        for(let i=0;i<CounterPartyTicketList.length;i++){
          for(let j=0;j<CounterPartyTicketList[i].harvestYear.length;j++){
            commarray.push({
              id: CounterPartyTicketList[i].harvestYear[j],
          name: CounterPartyTicketList[i].harvestYear[j]
        })
          }
        }  
        // Remove duplicates based on the 'id'
      }
      const uniqueCommArray = Array.from(new Map(commarray.map(item => [item.id, item])).values());
      return uniqueCommArray
    }
  }
  getFarmList = () =>{
    const { CounterPartyTicketList
    } = this.props;
    if(isCounterParty()){
      let commarray = [];
      if (isCounterParty() && CounterPartyTicketList && CounterPartyTicketList.length > 0) {
        // Create an array of objects with id and name
        commarray = CounterPartyTicketList.map(value => ({
          id: value.id,
          name: value.name
        }));
    
        // Remove duplicates based on the 'id'
      }
      const uniqueCommArray = Array.from(new Map(commarray.map(item => [item.id, item])).values());
  
      return uniqueCommArray
    }
  }
  // getSubFarmList = (id) =>{
  //   const { CounterPartyTicketList
  //   } = this.props;
  //   let subFarms = []
  //   for(let i=0;i<CounterPartyTicketList.length ;i++){
  //     let parent = true
  //     if(CounterPartyTicketList[i].id === id){
  //       console.log(CounterPartyTicketList,i,id,'checkkkk')
  //         for(let j = i;j<CounterPartyTicketList.length;j++){
  //          if(CounterPartyTicketList[j].parentId ==="-1"){
  //           parent = false
  //          }
  //          if(parent || CounterPartyTicketList[j].parentId !=="-1"){
  //           subFarms.push(CounterPartyTicketList[j])
  //          }
  //         }
  //     }
  //   }
  //   this.setState({subFarms:subFarms})
  // }
  getContractOptionsList = () => {
    const { ContractList, counterPartyDashboard } = this.props;
    let comm = ContractList !== undefined ? ContractList : {};
    let commarray = [];
    commarray = Object.keys(comm)
      .filter(value => !comm[value].disable)
      .map(value => {
        return {
          id: comm[value].id,
          name: comm[value].name
        };
      });
    return commarray;
  };
  getDestinationOptionsList = () => {
    const {
      ExternalDestinationOptions = [],
      InternalDestinationOptions = [],
      harvestData
    } = this.props;
    const destinationList = [
      ...ExternalDestinationOptions,
      ...InternalDestinationOptions
    ];
    const { counterPartyDashboard } = this.props;
  if(isCounterParty() && harvestData){
   return harvestData.DESTINATION
  }

    return destinationList;
  };

  getOriginList = () => {
    const {
      OriginTypeFieldBased = [],
      InternalDestinationOptions = []
    } = this.props;
    var onSite = [...InternalDestinationOptions];
    // onSite.length > 0 &&
    onSite = onSite.map(value => {
      const el = { ...value };
      el.name = el.name + " (On-site)";
      return el;
    });
    let FieldBased =
      OriginTypeFieldBased.length > 0 &&
      OriginTypeFieldBased.map(value => {
        value.id = value.id + "_1";
        value["name"] = value.name + " (Field)";
        return value;
      });

    const originList = [...FieldBased, ...onSite];
    this.setState({ getOriginListOptions: originList });
  };

  onRangeSelect = range => {
    const { start, end } = range;
    if (range) {
      this.setState(prevState => {
        return {
          reportsFilter: {
            ...prevState.reportsFilter,
            startdate: new Date(moment(start._d).format()).toISOString(),
            enddate: new Date(
              moment(end._d)
                .add({ hours: 23, minutes: 59 })
                .format()
            ).toISOString()
          }
        };
      });
    }
  };

  getVariertyList = (id, VarietyId) => {
    const { commodityVarietyList } = this.props;
    let option = commodityVarietyList.filter(
      value => value.commodityResponseDTO.id === id
    );
    this.setState(prevState => {
      return {
        ...prevState,
        commodityVarietyListOption: option
      };
    });
  };
  counterTrucklistoption = () => {
    const { counterPartyDashboard, harvestData } = this.props;
  
    let commarray = [];
    if (isCounterParty() && harvestData && harvestData.TRUCKLINE) {
      // Create an array of objects with id and name
     return harvestData.TRUCKLINE
  
      // Remove duplicates based on the 'id'
    }
    const uniqueCommArray = Array.from(new Map(commarray.map(item => [item.id, item])).values());

    return uniqueCommArray
  }
  getVariertyListforCounterparty = () => {
    const { counterPartyDashboard } = this.props;
  
    if (counterPartyDashboard.length > 0) {
      // Create an array of objects with id and name
      const commarray = counterPartyDashboard.map(value =>  Object.assign({}, value.commodityVarietyResponseDTO, {name:value.commodityVarietyResponseDTO.variety})
      );
      const uniqueCommArray = Array.from(new Map(commarray.map(item => [item.id, item])).values());

      // Filter duplicates based on the 'id'
      // Set the state with the unique values
      this.setState(prevState => ({
        ...prevState,
        commodityVarietyListOption: uniqueCommArray
      }));
    }
  }
  handleReset = () => {
    this.setState(
      prevState => {
        return {
          reportsFilter: {
            ...prevState.reportsFilter,
            startdate: "",
            enddate:"",
          }
        };
      },
     
    );
  }
  render() {
    const {
      successMessage,
      isValid,
      reportsFilter,
      getOriginListOptions,
      dateRangeValue,
      commodityVarietyListOption,
      comodityVariety,
      subFarms
    } = this.state;
    const {
      LoadNumberIndicatorList,
      BrokerList,
      trucksListOptions,
      getfilterCommodityVarietyList
    } = this.props;
    // if (successMessage) {
    //   return <Redirect to="/farmsetup/trucklines" />;
    // }
    return (
      <div className="reportFormList">
        <Grid container spacing={24} height={200}>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <DataRangePicker onResetData={()=>this.handleReset()} onSelect={range => this.onRangeSelect(range)} />
          </Grid>
          {!isCounterParty()  && <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.contract}
              label="Contract"
              type="text"
              name="contract"
              //validations={['required']}
              handleChange={this.handleChange}
              // handleError={this.handleError}
              options={this.getContractOptionsList()}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>}
          {isCounterParty()  && <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.farm}
              label="Farm"
              type="text"
              name="farm"
              //validations={['required']}
              handleChange={this.handleChange}
              // handleError={this.handleError}
              options={this.getFarmList()}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>}
          {/* {isCounterParty()  && <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.subFarm}
              label="SubFarm"
              type="text"
              name="subFarm"
              //validations={['required']}
              handleChange={this.handleChange}
              // handleError={this.handleError}
              options={subFarms}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>} */}
          {isCounterParty()  && <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.status}
              label="Status"
              type="text"
              name="status"
              //validations={['required']}
              handleChange={this.handleChange}
              // handleError={this.handleError}
              options={this.getStatusOptionsList()}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>}
          {!isCounterParty()  &&<Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.originId}
              label="Origin"
              type="text"
              name="originId"
              //validations={['required']}
              handleChange={this.handleChange}
              options={getOriginListOptions}
              //   handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>}
          {!isCounterParty()  &&<Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.loadnumberindicator}
              label="Load No Indicator"
              type="text"
              name="loadnumberindicator"
              options={LoadNumberIndicatorList}
              //validations={['required']}
              handleChange={this.handleChange}
              //handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>}
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.commodity}
              label="Commodity"
              type="text"
              name="commodity"
              //validations={['required']}
              options={this.getfilterCommodityList()}
              handleChange={this.handleChange}
              // handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>
          {/* <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.commodityVarietyListOption}
              label="Commodity Variety"
              type="text"
              name="commodityVarietyListOption"
              //validations={['required']}
              options={commodityVarietyListOption}
              handleChange={this.handleChange}
              // handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid> */}

             {!isCounterParty()  && <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              label="Commodity Variety"
              isMulti
              value={reportsFilter.commodityVariety}
              options={commodityVarietyListOption}
              handleChange={this.multiSelectHandleChange}
              selectedOptions={comodityVariety.selectedOptions}
            />
          </Grid>}

          {!isCounterParty()  &&<Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.counterpart}
              label="Counterpart"
              type="text"
              name="counterpart"
              options={BrokerList}
              //validations={['required']}
              handleChange={this.handleChange}
              //handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>}
          {<Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.destination}
              label="Destination"
              type="text"
              name="destination"
              options={this.getDestinationOptionsList()}
              // validations={['required']}
              handleChange={this.handleChange}
              // handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>}
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.truckline}
              label="Truckline"
              type="text"
              name="truckline"
              options={isCounterParty() ? this.counterTrucklistoption() :trucksListOptions}
              // validations={['required']}
              handleChange={this.handleChange}
              // handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>
          {/* {isCounterParty()  &&<Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.destination}
              label="Truck Driver Name"
              type="text"
              name="truckDriverName"
              options={this.getDestinationOptionsList()}
              handleChange={this.handleChange}
            />
          </Grid>} */}
          {isCounterParty()  &&<Grid item lg={3} md={3} sm={6} xs={12}>
            <Dropdown
              value={reportsFilter.harvestYear ? reportsFilter.harvestYear : this.getHarvestYearOptionsList()? this.getHarvestYearOptionsList()[0] ? this.getHarvestYearOptionsList()[0].id:'':''}
              label="Harvest Year"
              type="text"
              name="harvestYear"
              options={this.getHarvestYearOptionsList()}
              // validations={['required']}
              handleChange={this.handleChange}
              isClearable={false}
              // handleError={this.handleError}
              // disabled={ticketInfo.destinationType === 'external'}
            />
          </Grid>}
          {/* <Grid item md={3} implementation="css" smDown component={Hidden} />
          <Grid item md={3} implementation="css" smDown component={Hidden} /> */}

          {/* <Grid item lg={3} md={3} sm={6} xs={12}> */}
           
          {/* </Grid> */}
        </Grid>
        <div className="flex-display ticket-header generateReport">
              <Link to="#" style={{ marginLeft: "auto" }}>
                <Button name="Generate Report" onclick={this.generateReport} />
              </Link>
            </div>
        {/* {this.state.showDateRange ? (
          <DatePickerRange handleDateRange={this.handleDateRange} />
        ) : null} */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ContractList: state.contractReducer.ContractList,
    commodityList: state.contractReducer.commodityList,
    commodityVarietyList: state.contractReducer.commodityVarietyList,
    ContractStageList: state.contractReducer.ContractStageList,
    ContractTypeList: state.contractReducer.ContractTypeList,
    BrokerList: state.ticketReducer.CounterPart,
    OriginTypeFieldBased: state.ticketReducer.originTypeInternal,
    LoadNumberIndicatorList: state.ticketReducer.LoadNumberIndicatorList,
    ExternalDestinationOptions: state.contractReducer.DestinationList,
    InternalDestinationOptions: state.contractReducer.InternalDestinationList,
    selectedContractDetails: state.contractReducer.selectedContractDetails,
    trucksListOptions: state.trucklineReducer.trucksList,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear,
    counterPartyDashboard: state.ticketReducer.counterPartyDashboard,
    CounterPartyTicketList: state.ticketReducer.CounterPartyTicketList,
    harvestData:state.ticketReducer.harvestData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        commodityList,
        getCommodityVariertyList,
        getCounterpartList,
        getContractStage,
        getContractType,
        getAllContractList,
        getOriginType,
        getCounterPartyDashboard,
        getDataFromHarvestYear,
        getDestinationByType,
        getLoadNumberIndicatorList,
        InternalDestinationList,
        trucklineListAction,
        getSelectedContractDetail,
        getAllTicketList,
        getCounterPartyTicketList
      },
      dispatch
    )
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportsFormList);



// WEBPACK FOOTER //
// ./src/components/private/Reports/ReportsFormList.js